import { render, staticRenderFns } from "./RootProjectsList.vue?vue&type=template&id=fca8af40&"
import script from "./RootProjectsList.vue?vue&type=script&lang=ts&"
export * from "./RootProjectsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports